module.exports = class Alert {

	constructor() {
		this.initialize();
	}

	async initialize() {
		if (!this.initialized) {
			this.initialized = true;
      window.addEventListener('load', function () {
        const alertEls = window.document.querySelectorAll('.component-alert');
        for (let i = 0; i < alertEls.length; i++) {
          alertEls[i].addEventListener('click', function(e) {
            if (e.target.classList.contains('component-alert__heading-btn') || e.target.classList.contains('component-alert__heading-btn-icon')) {
              let openStatus = alertEls[i].getAttribute('data-open');
              openStatus = openStatus === 'true' ? true : false;
              alertEls[i].setAttribute('data-open', !openStatus);
              
              let expandedStatus = alertEls[i].querySelector('.component-alert__heading-btn').getAttribute('aria-expanded') === 'true' ? true : false;
              alertEls[i].querySelector('.component-alert__heading-btn').setAttribute('aria-expanded', (!expandedStatus).toString());
            }
          });
        }
      })
		}
	}

};